import Decimal from "decimal.js-light";

type StopWithLoadmeters = { loadmeters: number | string | null };

// With loadmeters hidden the user can't move them to another pickup
// themselves, so removing a pickup hands its loadmeters to the next remaining
// one (the previous one when removing the last). This keeps the pickup total,
// so the dropoffs still match it.
//
// Returns which pickup receives the loadmeters and its new value, or null
// when there is no other pickup to receive them.
export const moveRemovedPickupLoadmeters = (
  pickups: StopWithLoadmeters[],
  removedIndex: number
): { targetIndex: number; loadmeters: number } | null => {
  if (pickups.length < 2) {
    return null;
  }
  const targetIndex =
    removedIndex + 1 < pickups.length ? removedIndex + 1 : removedIndex - 1;
  return {
    targetIndex,
    loadmeters: new Decimal(pickups[targetIndex].loadmeters || 0)
      .add(pickups[removedIndex].loadmeters || 0)
      .toNumber(),
  };
};
